(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var predictiveControllers = new WeakMap();

  function rootUrl() {
    var root = document.body && document.body.dataset.arproRootUrl || "/";
    return root.endsWith("/") ? root : root + "/";
  }

  function debounce(callback, delay) {
    var timer = null;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = window.setTimeout(function () { callback.apply(null, args); }, delay);
    };
  }

  function createText(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = text || "";
    return node;
  }

  function hasAuthoritativePriceContext(root) {
    var context = root && root.closest("[data-arpro-context-authoritative]");
    if (!context || context.dataset.arproContextAuthoritative !== "true") return false;
    var mode = String(context.dataset.arproAuthoritativeMode || "").trim().toUpperCase();
    return mode === "TRAD" || mode === "GROSSISTES";
  }

  function closePredictive(root) {
    var panel = root.querySelector("[data-arpro-predictive-panel]");
    var input = root.querySelector("[data-arpro-predictive-input]");
    if (!panel || !input) return;
    panel.hidden = true;
    input.setAttribute("aria-expanded", "false");
    input.removeAttribute("aria-activedescendant");
  }

  function optionNode(item, index) {
    var link = document.createElement("a");
    link.className = "arpro-predictive__option";
    link.href = item.url;
    link.id = "ArproPredictiveOption-" + index;
    link.setAttribute("role", "option");
    link.setAttribute("aria-selected", "false");
    link.tabIndex = -1;

    if (item.image && item.image.url) {
      var image = document.createElement("img");
      image.src = item.image.url;
      image.alt = item.image.alt || "";
      image.loading = "lazy";
      link.appendChild(image);
    } else {
      var placeholder = createText("span", "arpro-predictive__image-placeholder", "");
      placeholder.setAttribute("aria-hidden", "true");
      link.appendChild(placeholder);
    }

    var copy = document.createElement("span");
    copy.appendChild(createText("strong", "", item.title));
    if (item.vendor || item.type) copy.appendChild(createText("small", "", item.vendor || item.type));
    link.appendChild(copy);
    return link;
  }

  function renderPredictive(root, data, query) {
    if (!hasAuthoritativePriceContext(root)) {
      closePredictive(root);
      return;
    }
    var panel = root.querySelector("[data-arpro-predictive-panel]");
    var input = root.querySelector("[data-arpro-predictive-input]");
    if (!panel || !input) return;
    panel.replaceChildren();

    var resources = data && data.resources && data.resources.results || {};
    var groups = [
      { key: "products", label: "Produits" },
      { key: "collections", label: "Familles et collections" },
      { key: "pages", label: "Informations" }
    ];
    var optionIndex = 0;
    groups.forEach(function (group) {
      var items = Array.isArray(resources[group.key]) ? resources[group.key] : [];
      if (items.length === 0) return;
      var container = document.createElement("section");
      container.className = "arpro-predictive__group";
      container.appendChild(createText("h2", "arpro-predictive__heading", group.label));
      items.slice(0, 6).forEach(function (item) {
        container.appendChild(optionNode(item, optionIndex));
        optionIndex += 1;
      });
      panel.appendChild(container);
    });

    var fullSearch = document.createElement("a");
    fullSearch.className = "arpro-predictive__option";
    fullSearch.href = rootUrl() + "search?q=" + encodeURIComponent(query) + "&type=product";
    fullSearch.id = "ArproPredictiveOption-" + optionIndex;
    fullSearch.setAttribute("role", "option");
    fullSearch.setAttribute("aria-selected", "false");
    fullSearch.tabIndex = -1;
    fullSearch.appendChild(createText("span", "", ""));
    fullSearch.appendChild(createText("strong", "", "Voir tous les résultats pour « " + query + " »"));
    panel.appendChild(fullSearch);
    optionIndex += 1;

    if (optionIndex === 1) panel.prepend(createText("p", "arpro-predictive__empty", "Aucun produit direct. Lancez la recherche complète."));
    panel.hidden = false;
    input.setAttribute("aria-expanded", "true");
  }

  function initializePredictive(root) {
    if (root.dataset.arproPredictiveInitialized === "true") return;
    var input = root.querySelector("[data-arpro-predictive-input]");
    var panel = root.querySelector("[data-arpro-predictive-panel]");
    if (!input || !panel) return;
    root.dataset.arproPredictiveInitialized = "true";
    var activeIndex = -1;

    var request = debounce(async function () {
      var query = input.value.trim();
      var previous = predictiveControllers.get(root);
      if (query.length < 3 || !hasAuthoritativePriceContext(root)) {
        if (previous) previous.abort();
        closePredictive(root);
        return;
      }
      if (previous) previous.abort();
      var controller = new AbortController();
      predictiveControllers.set(root, controller);
      panel.hidden = false;
      panel.replaceChildren(createText("p", "arpro-predictive__status", "Recherche en cours…"));
      input.setAttribute("aria-expanded", "true");
      try {
        var url = rootUrl() + "search/suggest.json?q=" + encodeURIComponent(query)
          + "&resources[type]=product,collection,page&resources[limit]=6"
          + "&resources[options][unavailable_products]=hide";
        var response = await fetch(url, { credentials: "same-origin", signal: controller.signal, headers: { Accept: "application/json" } });
        if (!response.ok) throw new Error("predictive-search-failed");
        renderPredictive(root, await response.json(), query);
        activeIndex = -1;
      } catch (error) {
        if (error.name === "AbortError") return;
        panel.replaceChildren(createText("p", "arpro-predictive__empty", "Suggestions indisponibles. Validez pour lancer la recherche."));
      }
    }, 180);

    input.addEventListener("input", request);
    input.addEventListener("keydown", function (event) {
      var options = Array.from(panel.querySelectorAll("[role='option']"));
      if (event.key === "Escape") {
        closePredictive(root);
        return;
      }
      if (panel.hidden || options.length === 0) return;
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        event.preventDefault();
        activeIndex += event.key === "ArrowDown" ? 1 : -1;
        if (activeIndex < 0) activeIndex = options.length - 1;
        if (activeIndex >= options.length) activeIndex = 0;
        options.forEach(function (option, index) { option.setAttribute("aria-selected", index === activeIndex ? "true" : "false"); });
        input.setAttribute("aria-activedescendant", options[activeIndex].id);
        options[activeIndex].scrollIntoView({ block: "nearest", behavior: reduceMotion ? "auto" : "smooth" });
      } else if (event.key === "Enter" && activeIndex >= 0 && options[activeIndex]) {
        event.preventDefault();
        window.location.assign(options[activeIndex].href);
      }
    });
  }

  function setFilterPanel(panel, open, trigger) {
    if (!panel) return;
    panel.dataset.open = open ? "true" : "false";
    panel.setAttribute("aria-hidden", open ? "false" : "true");
    document.documentElement.classList.toggle("arpro-filters-open", open);
    if (open) {
      panel.dataset.arproReturnFocus = trigger && trigger.id || "";
      var first = panel.querySelector("button, input, select, a[href]");
      if (first) first.focus();
    } else {
      var returnTarget = panel.dataset.arproReturnFocus && document.getElementById(panel.dataset.arproReturnFocus);
      if (returnTarget) returnTarget.focus();
    }
  }

  function initializeArchitecture(root) {
    (root || document).querySelectorAll("[data-arpro-predictive]").forEach(initializePredictive);
  }

  document.addEventListener("click", function (event) {
    var open = event.target.closest("[data-arpro-filters-open]");
    if (open) {
      setFilterPanel(document.getElementById(open.getAttribute("aria-controls")), true, open);
      return;
    }
    var close = event.target.closest("[data-arpro-filters-close]");
    if (close) {
      setFilterPanel(close.closest("[data-arpro-filter-panel]"), false);
      return;
    }
    document.querySelectorAll("[data-arpro-predictive]").forEach(function (root) {
      if (!root.contains(event.target)) closePredictive(root);
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var panel = document.querySelector("[data-arpro-filter-panel][data-open='true']");
    if (panel) setFilterPanel(panel, false);
  });

  document.addEventListener("change", function (event) {
    var sort = event.target.closest("[data-arpro-native-sort]");
    if (sort && sort.form) sort.form.requestSubmit();
  });

  var persistPo = debounce(async function (input) {
    var status = input.closest("[data-arpro-cart-po]") && input.closest("[data-arpro-cart-po]").querySelector("[data-arpro-cart-po-status]");
    if (status) status.textContent = "Enregistrement…";
    try {
      var response = await fetch(rootUrl() + "cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { "Référence commande client": input.value.trim() } })
      });
      if (!response.ok) throw new Error("po-update-failed");
      document.querySelectorAll("[data-arpro-cart-po-input]").forEach(function (candidate) {
        if (candidate !== input) candidate.value = input.value;
      });
      if (status) status.textContent = "Référence enregistrée.";
    } catch (error) {
      if (status) status.textContent = "Référence non enregistrée. Réessayez avant validation.";
    }
  }, 450);

  document.addEventListener("input", function (event) {
    var input = event.target.closest("[data-arpro-cart-po-input]");
    if (input) persistPo(input);
  });

  document.addEventListener("arpro:sections-updated", function (event) {
    initializeArchitecture(event.detail && event.detail.root || document);
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initializeArchitecture(document); });
  else initializeArchitecture(document);
})();
